<script setup>
import { computed } from 'vue'
import { useActiveAnnouncements } from '../composables/useActiveAnnouncements.js'

const { visibleModalItems, dismiss } = useActiveAnnouncements()

const currentModal = computed(() => visibleModalItems.value[0] || null)

function closeModal() {
  const item = currentModal.value
  if (!item) return
  dismiss(item.id, { persist: item.dismissible !== false })
}

function onBackdropClick() {
  if (currentModal.value?.dismissible) {
    closeModal()
  }
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="currentModal"
      class="fixed inset-0 z-[10020] flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="`announcement-modal-title-${currentModal.id}`"
      @click="onBackdropClick"
    >
      <div
        class="w-full max-w-md rounded-2xl bg-white px-7 py-9 shadow-xl sm:px-8 sm:py-10"
        @click.stop
      >
        <h2
          :id="`announcement-modal-title-${currentModal.id}`"
          class="text-center text-lg font-semibold leading-snug text-gray-900"
        >
          {{ currentModal.title }}
        </h2>
        <p class="mt-5 whitespace-pre-wrap text-sm leading-relaxed text-gray-600 sm:mt-6">
          {{ currentModal.content }}
        </p>
        <button
          type="button"
          class="mt-7 w-full rounded-xl bg-blue-600 py-3 text-sm font-semibold text-white transition-colors hover:bg-blue-700 sm:mt-8"
          @click="closeModal"
        >
          我知道了
        </button>
      </div>
    </div>
  </Teleport>
</template>
